import script from "./ProfileCompanyAnimationDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCompanyAnimationDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCompanyAnimationDrawer.vue?vue&type=style&index=0&id=5da0c811&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5da0c811"]])

export default __exports__